import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PageMeta from '../../components/PageMeta';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    nom: '', email: '', motDePasse: '', confirmPassword: '',
    role: 'student', numeroPasseport: '', nationalite: '',
    universiteOrigine: '', filiere: '', telephone: '', adresse: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (field, value) => setForm({ ...form, [field]: value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.motDePasse !== form.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const data = { ...form };
      delete data.confirmPassword;
      if (data.role !== 'student') { delete data.numeroPasseport; delete data.nationalite; delete data.universiteOrigine; delete data.filiere; }
      if (data.role !== 'owner') { delete data.adresse; }
      const user = await register(data);
      navigate(`/dashboard/${user.role}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur d\'inscription');
    } finally {
      setLoading(false);
    }
  };

  const roleOpts = [
    { value: 'student', label: 'Étudiant' },
    { value: 'owner', label: 'Propriétaire' },
  ];

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <PageMeta title="Inscription" />
      <div className="w-full max-w-lg mx-4">
        <div className="card-root p-8">
          <div className="text-center mb-8">
            <h1 className="font-serif text-3xl font-bold tracking-tight" style={{ color: '#0A192F' }}>Inscription</h1>
            <p className="mt-2 text-sm" style={{ color: '#7A828A' }}>Créez votre compte UNIKOL</p>
          </div>

          {error && (
            <div className="mb-6 p-3 text-sm font-semibold uppercase tracking-wider"
              style={{ backgroundColor: '#FFF0F0', color: '#D32F2F', border: '2px solid #D32F2F' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            {step === 1 && (
              <>
                <div className="flex gap-3 mb-4">
                  {roleOpts.map((opt) => (
                    <button key={opt.value} type="button"
                      className={`flex-1 py-3 text-sm font-bold tracking-wider uppercase border-2 transition-all ${
                        form.role === opt.value
                          ? 'border-[#C59B6C] text-[#0A192F]'
                          : 'border-[#E5E5E0] text-[#7A828A]'
                      }`}
                      style={{ backgroundColor: form.role === opt.value ? '#F4F4F0' : '#FFFFFF' }}
                      onClick={() => update('role', opt.value)}>
                      {opt.label}
                    </button>
                  ))}
                </div>
                <div>
                  <p className="label-root mb-1.5">Nom complet</p>
                  <input className="input-root" value={form.nom} onChange={(e) => update('nom', e.target.value)} required />
                </div>
                <div>
                  <p className="label-root mb-1.5">Email</p>
                  <input type="email" className="input-root" value={form.email} onChange={(e) => update('email', e.target.value)} required />
                </div>
                <div>
                  <p className="label-root mb-1.5">Téléphone</p>
                  <input className="input-root" value={form.telephone} onChange={(e) => update('telephone', e.target.value)} required />
                </div>
                <div>
                  <p className="label-root mb-1.5">Mot de passe</p>
                  <input type="password" className="input-root" value={form.motDePasse} onChange={(e) => update('motDePasse', e.target.value)} required minLength={6} />
                </div>
                <div>
                  <p className="label-root mb-1.5">Confirmer le mot de passe</p>
                  <input type="password" className="input-root" value={form.confirmPassword} onChange={(e) => update('confirmPassword', e.target.value)} required />
                </div>
                <button type="button" className="btn-primary-root w-full py-3" onClick={() => setStep(2)}>Suivant</button>
              </>
            )}
            {step === 2 && (
              <>
                {form.role === 'student' && (
                  <>
                    <div>
                      <p className="label-root mb-1.5">Numéro de passeport</p>
                      <input className="input-root" value={form.numeroPasseport} onChange={(e) => update('numeroPasseport', e.target.value)} required />
                    </div>
                    <div>
                      <p className="label-root mb-1.5">Nationalité</p>
                      <input className="input-root" value={form.nationalite} onChange={(e) => update('nationalite', e.target.value)} required />
                    </div>
                    <div>
                      <p className="label-root mb-1.5">Université d'origine</p>
                      <input className="input-root" value={form.universiteOrigine} onChange={(e) => update('universiteOrigine', e.target.value)} />
                    </div>
                    <div>
                      <p className="label-root mb-1.5">Filière</p>
                      <input className="input-root" value={form.filiere} onChange={(e) => update('filiere', e.target.value)} />
                    </div>
                  </>
                )}
                {form.role === 'owner' && (
                  <div>
                    <p className="label-root mb-1.5">Adresse</p>
                    <input className="input-root" value={form.adresse} onChange={(e) => update('adresse', e.target.value)} required />
                  </div>
                )}
                <div className="flex gap-3">
                  <button type="button" className="btn-outline-root flex-1 py-3" onClick={() => setStep(1)}>Retour</button>
                  <button type="submit" className="btn-primary-root flex-1 py-3" disabled={loading}>
                    {loading ? 'Inscription...' : 'Créer mon compte'}
                  </button>
                </div>
              </>
            )}
          </form>

          <p className="mt-6 text-center text-sm" style={{ color: '#7A828A' }}>
            Déjà un compte ?{' '}
            <Link to="/login" style={{ color: '#C59B6C', fontWeight: 700 }}>Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
